"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogClient = exports.flush = exports.setEventLoggingPaused = exports.setNetworkIsActive = exports.setFeatureSwitches = exports.setEntityType = exports.setPath = exports.setRoute = exports.setProductArea = exports.setOnEvent = exports.setMetadata = exports.getSite = exports.getFeatureSetId = exports.getEntityId = exports.setCustomEndpoint = exports.setSite = exports.setFeatureSetId = exports.setEntityId = exports.setSend = exports.init = exports.logRequestError = exports.logDuration = exports.logMessage = exports.logException = exports.logMonsterverseMessage = exports.logMonsterversePerfStats = exports.sendMetrics = exports.logStartExperiment = exports.logConvertExperiment = exports.logEvent = exports.logExposure = exports.getSessionId = exports.setSessionId = void 0;
require("console-polyfill");
var logging_1 = require("./logging");
var client_1 = require("./client");
Object.defineProperty(exports, "LogClient", {
  enumerable: true,
  get: function get() {
    return client_1.LogClient;
  }
});
var sessionId_1 = require("./sessionId");
Object.defineProperty(exports, "setSessionId", {
  enumerable: true,
  get: function get() {
    return sessionId_1.set;
  }
});
Object.defineProperty(exports, "getSessionId", {
  enumerable: true,
  get: function get() {
    return sessionId_1.get;
  }
});
var currentInstance;
function logExposure(data) {
  try {
    return currentInstance.logExposure(data);
  } catch (e) {
    handleError(e);
  }
}
exports.logExposure = logExposure;
function logEvent(rawData) {
  try {
    return currentInstance.logProductEvent(rawData);
  } catch (e) {
    handleError(e);
  }
}
exports.logEvent = logEvent;
function logConvertExperiment(experiment) {
  try {
    return currentInstance.logConvertExperiment(experiment);
  } catch (e) {
    handleError(e);
  }
}
exports.logConvertExperiment = logConvertExperiment;
function logStartExperiment(experiment) {
  return __awaiter(this, void 0, void 0, function () {
    var response, e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logStartExperiment(experiment)];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
        case 2:
          e_1 = _a.sent();
          handleError(e_1);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.logStartExperiment = logStartExperiment;
function sendMetrics(metrics) {
  return __awaiter(this, void 0, void 0, function () {
    var response, e_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logMetrics(metrics)];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
        case 2:
          e_2 = _a.sent();
          handleError(e_2);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.sendMetrics = sendMetrics;
function logMonsterversePerfStats(stats) {
  return __awaiter(this, void 0, void 0, function () {
    var response, e_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logMonsterversePerfStats(stats)];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
        case 2:
          e_3 = _a.sent();
          handleError(e_3);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.logMonsterversePerfStats = logMonsterversePerfStats;
function logMonsterverseMessage(log) {
  return __awaiter(this, void 0, void 0, function () {
    var response, e_4;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logMonsterverseMessage(log)];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
        case 2:
          e_4 = _a.sent();
          handleError(e_4);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.logMonsterverseMessage = logMonsterverseMessage;
function logException(error, info) {
  return __awaiter(this, void 0, void 0, function () {
    var response, e_5;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logException(error, info)];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
        case 2:
          e_5 = _a.sent();
          handleError(e_5);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.logException = logException;
function logMessage(logType, message) {
  return __awaiter(this, void 0, void 0, function () {
    var response, e_6;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logMessage(logType, message)];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
        case 2:
          e_6 = _a.sent();
          handleError(e_6);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.logMessage = logMessage;
function logDuration(data) {
  return __awaiter(this, void 0, void 0, function () {
    var response, e_7;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logDuration(data)];
        case 1:
          response = _a.sent();
          return [2 /*return*/, response];
        case 2:
          e_7 = _a.sent();
          handleError(e_7);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.logDuration = logDuration;
function logRequestError(type, request, response, info) {
  return __awaiter(this, void 0, void 0, function () {
    var results, e_8;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4 /*yield*/, currentInstance.logRequestError(type, request, response, info)];
        case 1:
          results = _a.sent();
          return [2 /*return*/, results];
        case 2:
          e_8 = _a.sent();
          handleError(e_8);
          return [3 /*break*/, 3];
        case 3:
          return [2 /*return*/];
      }
    });
  });
}

exports.logRequestError = logRequestError;
function init(options) {
  var env = options.env;
  if (!env) {
    throw new Error("must provide env");
  }
  if (/prod/.test(env) || /usp/.test(env)) {
    env = "prod";
  }
  var validEnvs = ["testing", "prod", "dev", "testing-logclient", "dev-logclient"];
  if (validEnvs.indexOf(env) === -1) {
    throw new Error(env + " isn't one of " + validEnvs.join(", "));
  }
  options.env = env;
  if (options.initNewInstance) {
    return new client_1.LogClient(options);
  }
  currentInstance = new client_1.LogClient(options);
  return currentInstance;
}
exports.init = init;
function setSend(sender) {
  currentInstance.sender = sender;
}
exports.setSend = setSend;
function setEntityId(id) {
  currentInstance.entityId = id;
}
exports.setEntityId = setEntityId;
function setFeatureSetId(id) {
  currentInstance.featureSetId = id;
  currentInstance.setMetadata("featureSetId", id);
}
exports.setFeatureSetId = setFeatureSetId;
function setSite(site) {
  currentInstance.site = site;
}
exports.setSite = setSite;
function setCustomEndpoint(e) {
  currentInstance.customEndpoint = e;
}
exports.setCustomEndpoint = setCustomEndpoint;
function getEntityId() {
  return currentInstance.entityId;
}
exports.getEntityId = getEntityId;
function getFeatureSetId() {
  return currentInstance.featureSetId;
}
exports.getFeatureSetId = getFeatureSetId;
function getSite() {
  return currentInstance.site;
}
exports.getSite = getSite;
function setMetadata(key, value) {
  currentInstance.setMetadata(key, value);
}
exports.setMetadata = setMetadata;
function setOnEvent(f) {
  currentInstance.onEvent = f;
}
exports.setOnEvent = setOnEvent;
function setProductArea(productArea) {
  currentInstance.productArea = productArea;
}
exports.setProductArea = setProductArea;
function setRoute(route) {
  currentInstance.route = route;
}
exports.setRoute = setRoute;
function setPath(path) {
  currentInstance.path = path;
}
exports.setPath = setPath;
function setEntityType(entityType) {
  currentInstance.entityType = entityType;
}
exports.setEntityType = setEntityType;
function setFeatureSwitches(featureSwitches) {
  currentInstance.featureSwitches = featureSwitches;
}
exports.setFeatureSwitches = setFeatureSwitches;
/** @deprecated Testing of this feature in live codebases demonstrated a meaningful
 * dropoff in total event arrivals. We've renamed the behavior to accurately reflect
 * the underlying behavior as it might be useful. If you want to use this feature to
 * batch log events and send them while the network is already active, make sure you
 * verify that delivery isn't being impacted.
 **/
function setNetworkIsActive(isActive) {
  currentInstance.setEventLoggingPaused(!isActive);
}
exports.setNetworkIsActive = setNetworkIsActive;
function setEventLoggingPaused(isPaused) {
  currentInstance.setEventLoggingPaused(isPaused);
}
exports.setEventLoggingPaused = setEventLoggingPaused;
function flush() {
  currentInstance.flush();
}
exports.flush = flush;
function handleError(err) {
  var typedErr = typeof err === "string" ? new Error(err) : err;
  logging_1.warn(typedErr.message);
  var env = currentInstance.env;
  if (env === "testing" || env === "dev" || env === "testing-logclient") {
    throw typedErr;
  }
}